<template>
  <div>
    <img src="@/assets/images/logo/dksteel_print_logo.svg" alt="DK Steel Print Logo" class="mb-4" />
    <h1>{{ form.제품명 || "-" }}</h1>
    <template>
      <div class="warning-list">
        <div v-for="p in checkedPictograms" :key="p.key" :style="{ flexBasis: itemWidth, maxWidth: itemWidth, height: itemHeight }">
          <img :src="getPictogramImg(p.key)" :alt="p.label" />
          <p class="pictogram-code">{{ p.label }}</p>
        </div>
      </div>
    </template>
    <h2 v-if="form.경고표지요소 && form.경고표지요소.신호어 !== '없음'" class="mt-4" :class="form.경고표지요소.신호어 === '위험' ? 'danger' : 'warning'">
      {{ form.경고표지요소.신호어 === "위험" ? "위험(Danger)" : "경고(Warning)" }}
    </h2>

    <table>
      <colgroup>
        <col width="220" />
      </colgroup>
      <tr v-for="(row, i) in 유해위험문구표시" :key="`h_${i}`">
        <th v-if="i === 0" :rowSpan="유해위험문구표시.length">유해·위험문구</th>
        <td>{{ row.문구 || "-" }}</td>
      </tr>
    </table>

    <table>
      <colgroup>
        <col width="220" />
      </colgroup>
      <tr v-for="(row, i) in 예방조치문구표시" :key="`p_${i}`">
        <th v-if="i === 0" :rowSpan="예방조치문구표시.length">예방조치문구</th>
        <td>{{ row.문구 || "-" }}</td>
      </tr>
    </table>

    <table v-if="form.제조사 || form.제조사전화번호">
      <colgroup>
        <col width="220" />
        <col width="272" />
      </colgroup>
      <tr>
        <th rowSpan="2">공급자 정보</th>
        <th>제조사(공급사)</th>
        <td>{{ form.제조사 || "-" }}</td>
      </tr>
      <tr>
        <th>전화번호</th>
        <td>{{ form.제조사전화번호 || "-" }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { GHS_PICTOGRAM_LIST, getPictogramImg } from "./ghsConstants";

export default {
  name: "Print",
  props: {
    form: Object,
    board: Object,
  },
  computed: {
    checkedPictograms() {
      const 그림문자 = (this.form.경고표지요소 && this.form.경고표지요소.그림문자) || {};
      return GHS_PICTOGRAM_LIST.filter((p) => 그림문자[p.key]);
    },
    itemWidth() {
      const count = this.checkedPictograms.length;
      // 4개 이하면 개수만큼 균등 분할, 5개 이상이면 20% 고정
      const cols = count > 0 && count < 5 ? count : 5;
      return `${100 / cols}%`;
    },
    itemHeight() {
      return this.checkedPictograms.length <= 5 ? "400px" : "200px";
    },
    유해위험문구목록() {
      return (this.form.경고표지요소 && this.form.경고표지요소.유해위험문구) || [];
    },
    예방조치문구목록() {
      return (this.form.경고표지요소 && this.form.경고표지요소.예방조치문구) || [];
    },
    // 문구가 없는 문서도 표 자체는 출력하고 '-' 한 행으로 표시
    유해위험문구표시() {
      return this.유해위험문구목록.length ? this.유해위험문구목록 : [{ 문구: "-" }];
    },
    예방조치문구표시() {
      return this.예방조치문구목록.length ? this.예방조치문구목록 : [{ 문구: "-" }];
    },
  },
  methods: {
    getPictogramImg,
  },
};
</script>

<style scoped lang="scss">
h1 {
  font-weight: 700;
  font-style: Bold;
  font-size: 64px;
  text-align: center;
  padding: 32px 0;
  border: 4px solid #515151;
  margin-bottom: 24px;
}

h2 {
  font-weight: 700;
  font-style: Bold;
  font-size: 48px;
  text-align: center;
  padding: 20px 0;
  color: white;

  &.danger {
    background-color: #e42728;
  }
  &.warning {
    background-color: #ff8510;
  }
}
.warning-list {
  display: flex;
  flex-wrap: wrap;

  > div {
    box-sizing: border-box;
    border: 1px solid #757575;
    margin-right: -1px;
    margin-bottom: -1px;
    display: flex;
    flex-direction: column;

    img {
      display: block;
      width: 100%;
      flex: 1 1 auto; // 남은 공간을 이미지가 채움
      min-height: 0; // flex 자식이 줄어들 수 있도록
      object-fit: contain; // 비율 유지하면서 꽉 채움 (잘리지 않게)
      padding: 15px 15px 8px 15px;
      box-sizing: border-box;
    }

    p {
      font-weight: 700;
      font-size: 28px;
      text-align: center;
      color: #3c3c3c;
      margin: 0 0 8px;
      flex-shrink: 0; // 텍스트 영역은 고정
    }
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #757575;
  margin-top: 24px;

  th,
  td {
    border: 1px solid #757575;
  }

  th {
    font-weight: 700;
    font-style: Bold;
    font-size: 24px;
    text-align: center;
    vertical-align: middle;
    padding: 15px;
    background: #ececeecc;
  }
  td {
    font-weight: 400;
    font-size: 24px;
    text-align: center;
    vertical-align: middle;
    padding: 15px;
  }
}
</style>
